import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { InputTextModule } from 'primeng/inputtext';

import { AccountContactListComponent } from './account-contact-list.component';

@NgModule({
  declarations: [AccountContactListComponent],
  imports: [CommonModule, TableModule, ButtonModule, RippleModule, InputTextModule],
})
export class AccountContactListModule {}
